import { FiArrowRight, FiMonitor, FiSmartphone, FiPenTool, FiShield } from 'react-icons/fi';
import webImage from '../img/web2.jpg';
import uiImage from '../img/ui.png';

const capabilities = [
  { icon: FiMonitor, title: 'Web applications', text: 'Fast, responsive sites and platforms' },
  { icon: FiSmartphone, title: 'Mobile apps', text: 'iOS and Android experiences' },
  { icon: FiPenTool, title: 'UI/UX & branding', text: 'Interfaces people enjoy using' },
  { icon: FiShield, title: 'Secure & reliable', text: 'Encrypted, backed up, monitored' },
];

function Minatechnologies() {
  return (
    <div className="glow-light overflow-hidden pb-16 pt-32 sm:pt-36 lg:pb-20">
      <div className="wrap">
        <div className="grid items-center gap-14 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <span className="enter eyebrow" style={{ '--i': 0 }}>Software studio · Addis Ababa</span>
            <h1 className="enter display-xl mt-5 max-w-[17ch] text-ink" style={{ '--i': 1 }}>
              We build websites &amp; apps that <span className="text-gradient">grow your business</span>
            </h1>
            <p className="enter lede mt-6 text-muted" style={{ '--i': 2 }}>
              Mina Technologies designs and develops high-performing websites and apps that attract customers and
              grow your business. Let’s create your ideal digital presence.
            </p>
            <div className="enter mt-9 flex flex-wrap gap-3" style={{ '--i': 3 }}>
              <a href="#contactus" className="btn-primary group">
                Start a project <FiArrowRight className="transition-transform group-hover:translate-x-0.5" />
              </a>
              <a href="#services" className="btn-secondary">
                Our services
              </a>
            </div>
          </div>

          <div className="relative isolate lg:col-span-6">
            <div className="orb -right-10 -top-10 -z-10 h-64 w-64 bg-cyan/30" aria-hidden="true" />
            <div className="orb -bottom-12 left-10 -z-10 h-56 w-56 bg-brand/25" style={{ animationDelay: '-8s' }} aria-hidden="true" />

            <div className="enter card p-2.5 sm:p-3" style={{ '--i': 1 }}>
              <div className="enter-wipe overflow-hidden rounded-media">
                <img
                  src={webImage}
                  alt="Web and mobile solutions built by Mina Technologies"
                  className="aspect-[16/10] w-full object-cover"
                />
              </div>
            </div>
            <div className="enter-land absolute -bottom-8 -left-3 hidden w-44 sm:block lg:-left-8 lg:w-52">
              <div className="float-soft rounded-2xl bg-white p-2 shadow-float ring-1 ring-line">
                <img src={uiImage} alt="UI/UX design work" className="aspect-[4/3] w-full rounded-xl object-cover" />
              </div>
            </div>
            <div className="enter-slide absolute right-4 top-4 rounded-2xl border border-white/60 bg-white/85 px-4 py-3 shadow-float backdrop-blur-md">
              <p className="flex items-center gap-2 text-[0.7rem] font-semibold uppercase tracking-[0.16em] text-brand">
                <span className="live-dot" aria-hidden="true" /> What we build
              </p>
              <p className="font-display text-sm font-semibold text-ink">Web · Mobile · UI/UX</p>
            </div>
          </div>
        </div>

        <div className="enter glow-dark mt-20 grid overflow-hidden rounded-[1.75rem] sm:grid-cols-2 lg:mt-24 lg:grid-cols-4" style={{ '--i': 4 }}>
          {capabilities.map(({ icon: Icon, title, text }, index) => (
            <div key={title} className="enter group flex items-start gap-4 p-6 lg:p-7" style={{ '--i': 5 + index }}>
              <span className="icon-tile">
                <Icon size={20} />
              </span>
              <div>
                <p className="font-display font-semibold text-white">{title}</p>
                <p className="mt-1 text-sm text-subtle">{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Minatechnologies;
